<div
  class="default-overlay !content-start pt-[5rem]"
  appAlert
  [show]="show"
  (showChange)="showChange($event)"
>
  <div class="title">Bet Confirmed</div>
  <div class="description">
    Your are betting
    <div class="coins">{{ chips }} Coins</div>
    for
    <div class="bet">{{ bet | betToString }}</div>
  </div>
  <div class="xmark-container" (click)="showChange(false)">
    <fa-icon size="xl" [icon]="faXmark"></fa-icon>
  </div>
</div>
